<!-- 问题描述 -->
<template>
  <svg viewBox="0 0 1024 1024" fill="currentColor">
    <path
      d="M525.3 169.5c-229.7 0-410.5 198.4-414.7 422.5-4.6 233.1 196 418 422.3 422.1h7.7c227.2 0 406.5-194.3 414.5-415.3 0.2-2.3 0.4-4.6 0.2-7.2 0-2.5 0-4.8-0.2-7.2-8.2-229.7-191.3-410.7-422.2-415.1l-7.6 0.2z"
      fill="#FF9D00"
      p-id="39069"
    />
    <path
      d="M705.8 91.8a2.4 12.9 0 1 0 4.8 0 2.4 12.9 0 1 0-4.8 0Z"
      fill="#E61F19"
      p-id="39070"
    />
    <path
      d="M694.902192 95.721797a12.9 2.4 60 1 0 4.156922-2.4 12.9 2.4 60 1 0-4.156922 2.4Z"
      fill="#E61F19"
      p-id="39071"
    />
    <path
      d="M687.467235 104.62971a12.9 2.4 30 1 0 2.4-4.156922 12.9 2.4 30 1 0-2.4 4.156922Z"
      fill="#E61F19"
      p-id="39072"
    />
    <path
      d="M672.6 113.6a12.9 2.4 0 1 0 25.8 0 12.9 2.4 0 1 0-25.8 0Z"
      fill="#E61F19"
      p-id="39073"
    />
    <path
      d="M677.127961 131.26884a2.4 12.9 60 1 0 22.343456-12.9 2.4 12.9 60 1 0-22.343456 12.9Z"
      fill="#E61F19"
      p-id="39074"
    />
    <path
      d="M689.87433 144.303869a2.4 12.9 30 1 0 12.9-22.343456 2.4 12.9 30 1 0-12.9 22.343456Z"
      fill="#E61F19"
      p-id="39075"
    />
    <path
      d="M705 136.3a2.4 12.9 0 1 0 4.8 0 2.4 12.9 0 1 0-4.8 0Z"
      fill="#E61F19"
      p-id="39076"
    />
    <path
      d="M716.518271 134.699804a12.9 2.4 60 1 0 4.156922-2.4 12.9 2.4 60 1 0-4.156922 2.4Z"
      fill="#E61F19"
      p-id="39077"
    />
    <path
      d="M725.706088 127.553006a12.9 2.4 30 1 0 2.4-4.156921 12.9 2.4 30 1 0-2.4 4.156921Z"
      fill="#E61F19"
      p-id="39078"
    />
    <path
      d="M717.1 114.4a12.9 2.4 0 1 0 25.8 0 12.9 2.4 0 1 0-25.8 0Z"
      fill="#E61F19"
      p-id="39079"
    />
    <path
      d="M716.105968 109.652761a2.4 12.9 60 1 0 22.343456-12.9 2.4 12.9 60 1 0-22.343456 12.9Z"
      fill="#E61F19"
      p-id="39080"
    />
    <path
      d="M712.798127 106.065881a2.4 12.9 30 1 0 12.9-22.343455 2.4 12.9 30 1 0-12.9 22.343455Z"
      fill="#E61F19"
      p-id="39081"
    />
    <path
      d="M790.2 15.9m-15.6 0a15.6 15.6 0 1 0 31.2 0 15.6 15.6 0 1 0-31.2 0Z"
      fill="#2C65AF"
      p-id="39082"
    />
    <path
      d="M561 80.3c-2.4 0-4.4-1.9-4.4-4.4V28.1c0-2.4 1.9-4.4 4.4-4.4 2.4 0 4.4 1.9 4.4 4.4v47.8c0 2.4-2 4.4-4.4 4.4z"
      fill="#7CCBE2"
      p-id="39083"
    />
    <path
      d="M584.9 56.4h-47.8c-2.4 0-4.4-1.9-4.4-4.4 0-2.5 1.9-4.4 4.4-4.4h47.8c2.4 0 4.4 1.9 4.4 4.4 0 2.4-2 4.4-4.4 4.4z"
      fill="#7CCBE2"
      p-id="39084"
    />
    <path
      d="M934.4 223.5c-6-2.6-12.4-1.1-14.3 3.3l-37 85.7c-1.9 4.4 1.4 10.1 7.4 12.6 6 2.6 12.4 1.1 14.3-3.3l37-85.7c1.9-4.3-1.4-9.9-7.4-12.6z"
      fill="#2C65AF"
      p-id="39085"
    />
    <path
      d="M861.7 252.4c-2.6 6-1.1 12.4 3.3 14.3l85.7 37c4.4 1.9 10.1-1.4 12.6-7.4 2.6-6 1.1-12.4-3.3-14.3l-85.7-37c-4.4-1.9-10 1.5-12.6 7.4z"
      fill="#2C65AF"
      p-id="39086"
    />
    <path
      d="M872.8 158.4c-21.9 0-39.7-17.6-39.7-39.3s17.8-39.3 39.7-39.3c21.9 0 39.6 17.6 39.6 39.3s-17.7 39.3-39.6 39.3z m0-68.3c-16.1 0-29.2 13-29.2 28.9s13.1 28.9 29.2 28.9 29.2-13 29.2-28.9-13.1-28.9-29.2-28.9z"
      fill="#E62A52"
      p-id="39087"
    />
    <path
      d="M475.8 996.9h-8.1c-118.6-2.2-234.4-53-317.5-139.5C71.5 775.6 29.3 670 31.5 560.1c0.3-18.4 1.8-36.7 4.5-54.6 1.1-7.8 8.4-13.2 16.2-12.1 7.8 1.1 13.2 8.4 12.1 16.2-2.4 16.7-3.8 33.9-4.1 51.1-2.1 102.3 37.3 200.7 110.7 277 77.9 81 186.3 128.6 297.3 130.7h7.7c61.2 0 119.8-14.3 174.5-42.6 7-3.6 15.6-0.9 19.3 6.1 3.6 7 0.9 15.6-6.1 19.3C635 966 604.9 977.3 574 985c-32.1 7.9-65 11.9-98.2 11.9z m298.8-134.6c-3.4 0-6.9-1.3-9.7-3.8-5.8-5.3-6.2-14.4-0.9-20.2 68.6-74.9 108.3-171.3 112-271.5v-0.5l0.1-0.5c0.2-1.8 0.3-3.4 0.2-4.7l-0.1-0.5v-0.5c0-2.3 0-4.1-0.2-5.8l-0.1-0.9c-7.8-220.8-187.1-397.1-408-401.3h-7.4c-70.9 0-140.6 20-201.7 57.9-6.7 4.2-15.5 2.1-19.7-4.6-4.2-6.7-2.1-15.5 4.6-19.7 32.1-20 66.5-35.4 102.2-45.9 37.1-10.9 75.7-16.4 114.6-16.4h7.8c115.3 2.2 223.3 47.3 304.4 127.2 80.8 79.6 127.6 186.6 131.8 301.3 0.2 2.7 0.2 5.2 0.2 7.6 0.2 3.2 0 6.1-0.2 8.5-2 53.6-13.6 106.2-34.6 156.4-20.5 49.1-49.1 93.9-84.9 132.9-2.7 3.4-6.6 5-10.4 5z m-702.4-428c-1.7 0-3.3-0.3-4.9-0.9-7.4-2.7-11.2-10.9-8.5-18.4 16.8-45.8 40.5-88.3 70.6-126.5 4.9-6.2 13.9-7.3 20.1-2.4 6.2 4.9 7.3 13.9 2.4 20.1-28.3 35.8-50.5 75.7-66.2 118.6-2.2 5.9-7.7 9.5-13.5 9.5z"
      fill=""
      p-id="39088"
    />
    <path
      d="M200.8 522.6c-1.2 0-2.5-0.2-3.7-0.5-7.6-2-12.2-9.8-10.2-17.5 6.9-26.2 16-51.3 26.9-74.7 1.9-4.1 3.6-7.8 5.1-11.2 9.4-20.4 14.1-30.7 29.2-50.9 4.7-6.3 13.7-7.7 20-2.9 6.3 4.7 7.7 13.7 2.9 20-13.3 17.8-17 26-26.1 45.8-1.6 3.4-3.3 7.2-5.2 11.3-10.2 21.9-18.7 45.3-25.2 69.8-1.5 6.6-7.3 10.8-13.7 10.8z m95.9-179.5c-3.4 0-6.8-1.2-9.5-3.6-5.9-5.2-6.5-14.2-1.3-20.2 5.4-6.1 11-12.1 16.7-18 3.4-3.5 6.8-6.8 9.3-9.2 5.7-5.5 14.8-5.3 20.2 0.4 5.5 5.7 5.3 14.8-0.4 20.2-3.5 3.4-6.2 6-8.5 8.5l-0.1 0.1c-5.4 5.5-10.7 11.2-15.7 16.9-2.8 3.2-6.8 4.9-10.7 4.9z"
      fill="#FFFFFF"
      p-id="39089"
    />
    <path
      d="M474.1 791.2c2.2 2.6 4.7 3.9 7.3 3.9 4.5 0 8.8-1.9 12.9-5.8 11.8-9.7 25.9-26.9 42-52.1l13.6 7.8c-39.2 68.1-81 102.3-124.9 102.3-16.8 0-30.1-4.7-40.1-14.2-9.9-9.5-14.9-21.6-14.9-36 0-9.7 2.2-21.7 6.7-36.6l54.1-185.7c5.1-17.7 7.8-31 7.8-40 0-5.8-2.6-11-7.6-15.5s-11.6-6.7-20-6.7c-4.1 0-8.8 0.2-14 0.4l4.7-15.5L533.3 476h23.1l-79.7 276c-4.1 15.7-6.2 26.3-6.2 31.5 0.2 2.7 1.4 5.1 3.6 7.7zM573 395c-11.2 11-24.8 16.6-40.5 16.6-15.5 0-28.7-5.6-39.9-16.6-11-11.2-16.6-24.5-16.6-40.3s5.4-29.3 16.4-40.5c11-11.2 24.4-16.8 40-16.8 16.2 0 29.7 5.6 40.7 16.8 11 11.2 16.6 24.8 16.6 40.5 0.3 15.7-5.5 29.1-16.7 40.3z"
      fill="#FFFFFF"
      p-id="39090"
    />
    <path
      d="M425 861.5c-20.5 0-37.3-6.1-50-18.2-12.8-12.3-19.3-27.9-19.3-46.3 0-11.2 2.4-24.5 7.3-40.7l54-185.7c4.8-16.4 7.2-28.5 7.2-36 0-0.7 0-2.3-2.9-4.9-0.8-0.7-3.3-3-10.4-3-2.7 0-6 0.1-9.4 0.2-1.3 0.1-2.7 0.1-4.1 0.2-4.6 0.2-9-1.9-11.8-5.6s-3.7-8.5-2.3-12.9l4.7-15.5c1.6-5.2 6-9 11.4-10L531 461.8c0.7-0.1 1.5-0.2 2.3-0.2h23.1c4.5 0 8.8 2.1 11.4 5.7s3.5 8.2 2.3 12.6l-79.6 275.8c-3 11.3-4.4 18.2-5.1 22.3 10.9-8.9 24-25.3 39-48.7 4.1-6.4 12.5-8.5 19.2-4.7l13.6 7.8c3.3 1.9 5.7 5 6.7 8.7 1 3.7 0.5 7.6-1.4 10.9-20.4 35.4-41.9 62.5-64 80.6-23.6 19.2-48.3 28.9-73.5 28.9zM437.5 506c1.1 0.8 2.1 1.6 3.1 2.5 10.1 9.2 12.2 19.3 12.2 26.1 0 10.4-2.7 24.8-8.4 44l-54.1 185.7c0 0.1-0.1 0.1-0.1 0.2-4 13.3-6.1 24.2-6.1 32.4 0 10.5 3.4 18.9 10.5 25.7 7.2 6.9 17.1 10.2 30.2 10.2 19 0 37.9-7.9 56.6-23.6-7 0.1-13.5-3.1-18.4-9-4.2-5-6.5-10.2-7-15.8-0.1-0.4-0.1-0.8-0.1-1.2 0-4.4 0.7-12.4 6.7-35.1 0.1-0.1 0.1-0.2 0.1-0.3L537.1 490h-2.9l-96.7 16zM485 782z m47.5-356.1c-19.1 0-35.9-7-49.9-20.7l-0.2-0.2c-13.7-14-20.7-30.9-20.7-50.3 0-19.7 6.9-36.7 20.4-50.5 13.7-14 30.6-21.1 50.3-21.1 20.1 0 37.2 7.1 51 21.1 13.7 14 20.7 30.9 20.7 50.4 0.2 19.3-6.8 36.3-20.9 50.5l-0.1 0.1c-14.1 13.7-31.1 20.7-50.6 20.7z m-29.7-41.1c8.7 8.5 18.1 12.4 29.7 12.4 11.9 0 21.9-4.1 30.4-12.5 8.6-8.6 12.7-18.4 12.5-29.9v-0.2c0-12-4.1-21.9-12.5-30.5-8.2-8.4-18.2-12.5-30.5-12.5-11.8 0-21.6 4.1-29.8 12.5s-12.3 18.4-12.3 30.5c0.1 11.8 4.1 21.7 12.5 30.2zM573 395z"
      fill=""
      p-id="39091"
    />
  </svg>
</template>
